import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import {
  GET_REPORT_GAS_COMPOSITION,
  GET_ACCOUNT,
  GET_DETAIL_SHIFT_DATA,
  GET_RP_SHIFT,
  SAVE_RP_SHIFT,
  REFRESH_RP_SHIFT_DATA,
  SAVE_LIST_RP_SHIFT_DATA_REPORT,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";
import React, { createRef, useEffect, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";
import { post, postUpload } from "../../../helpers/api_helper";
import { AvField, AvForm } from "availity-reactstrap-validation";
import BootstrapTable from "react-bootstrap-table-next";
import Flatpickr from "react-flatpickr";
import OverButton from "../../../components/Custom/Overbutton";
// import OveruseByContact from "./OveruseByContact";
import PropTypes from "prop-types";
import Select from "react-select";
// import TableFour from "./TableFour";
// import TableOne from "./TableOne";
// import TableThree from "./TableThree";
// import TableTwo from "./TableTwo";
import logoPttColor from "../../../assets/images/PTT_LogoColor.png";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
//i18n
import { withTranslation } from "react-i18next";
import { users } from "common/data";

function DetailShiftReport(props) {

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "" || number == undefined) return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  let history = useHistory();
  let { pid, date } = useParams();

  // console.log(pid);
  // const tpaDailyReducer = useSelector(reducer => reducer.TPADailyReport);

  const dispatch = useDispatch();
  const permission = getPermission();
  const searchObj = {};
  // const createObj = {};
  const gcNameDailyPID = {};
  const model = {
    PID: "",
    SHIFT_APPROVE: null,
    SHIFT_LEVEL: null,
    SHIFT_DAILY: "",
    SHIFT_DESC: "",
    STATUS_EMAIL: 0,
    // LIST_12HOUR: [],
    // LIST_24HOUR: [],
  }

  const [modelDevice, setModelDevice] = useState(model);
  const [listDataFlow, setListDataFlow] = useState([]);

  const [list12Hour, setList12Hour] = useState([]);
  const [list24Hour, setList24Hour] = useState([]);
  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);
  const [pageAdd, setPageAdd] = useState(false);

  const [listUser, setListUser] = useState([]);
  const [dropDownUser, setDropDownUser] = useState(null);
  // const [dropDownShift, setDropDownShift] = useState(null);

  //onInit//
  useEffect(function () {
    fetchData();
  }, []);
  //onInit//

  const handleSelectDropDownUser = selected => {
    setDropDownUser(selected);
  };

  const SelectStyle = {
    option: (provided, { data, isDisabled, isFocused, isSelected }) => ({
      ...provided,
      ...isFocused && ({ backgroundColor: '#2E3460' })
    }),
  }

  const gotoMainMenu = () => {
    history.push({
      pathname: "/shift-report", state: {  // location state
        goBack: true,
      },
    });
  };

  const compare = (a, b) => {
    // console.log(a, b);
    if (a.ALIAS_NAME < b.ALIAS_NAME) {
      return -1;
    }
    if (a.ALIAS_NAME > b.ALIAS_NAME) {
      return 1;
    }
    return 0;
  }


  const fetchData = async () => {
    dispatch(loadingAction.showLoading());
    try {

      let [res, dataShiftList, dataUser] = await Promise.all([
        post(GET_DETAIL_SHIFT_DATA, { SHIFT_DAILY: date }),
        post(GET_RP_SHIFT, { PID: pid }),
        post(GET_ACCOUNT, { UNITNAME: "บค.", IS_LEADER_SHIFT: false }),
      ])

      let dataShift = dataShiftList.data.rpShiftList[0];
      setModelDevice({
        ...dataShift, SHIFT_LEVEL: dataShift.SHIFT_LEVEL == null ? "" : dataShift.SHIFT_LEVEL
      });

      let listDataUser = dataUser.data.AccountList.sort(compare).map((obj) => ({ label: obj.DISPLAY_NAME, value: obj.LOGIN_NAME, shift: obj.SHOW_SHIFT }));
      setListUser(listDataUser);

      // console.log(dataShift);

      if (dataShift.SHIFT_APPROVE == null) {
        setDropDownUser(null);
      } else {
        let user = listDataUser.find(obj => obj.value == dataShift.SHIFT_APPROVE);
        setDropDownUser(user);
      }


      setListDataFlow(res.data.rpShiftFlowList.map(item => {
        return {
          ...item, FLOWVOLUME: numberFormat(item.FLOWVOLUME, 1)
        }
      }
      ));

      let shiftScadaList = res.data.rpShiftScadaList;
      let shiftColumnName = res.data.rpShiftColumnList;
      // console.log(shiftScadaList);
      // console.log(shiftColumnName);
      let dataScada = shiftScadaList.map(item => {
        let dataColumn = shiftColumnName.find(row => {
          if (item.SHIFTCOLUMN_PID == row.PID) {
            return (
              true
            )
          }
          return (
            false
          )
        })
        // console.log(dataColumn);
        return { ...item, COLUMN_NAME: dataColumn.SHIFTCOLUMN_NAME, TIME_CHECK: item.SOURCE_DATE.slice(11), SHOW_DATA_SCADA: numberFormat(item.SCADA_DATA, 2), SCADA_DATA: item.SCADA_DATA.toFixed(2) }
      });
      // console.log(dataScada);
      if (dataScada != null) {
        let data12 = dataScada.filter((obj) => obj.TIME_CHECK == "12:00:00");
        let data24 = dataScada.filter((obj) => obj.TIME_CHECK != "12:00:00");
        setList12Hour(data12);
        setList24Hour(data24);
      } else {
        setList12Hour([]);
        setList24Hour([]);
      }

    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // useEffect(function () {
  //   console.log(list12Hour);
  //   console.log(list24Hour);
  // }, [list12Hour, list24Hour]);

  // useEffect(function () {
  //   console.log(modelDevice);
  // }, [modelDevice]);


  const validateForm = () => {
    let bResult = true;

    let element = document.querySelectorAll(".form-require")
    element.forEach(el => {
      if (el.classList.contains("is-invalid")) {
        el.classList.remove('is-invalid')
      }
    }
    );

    if (modelDevice.SHIFT_APPROVE == "" || modelDevice.SHIFT_APPROVE == null) {
      document.getElementById("SHIFT_APPROVE").classList.add('is-invalid');
      bResult = false;
    }

    return bResult;
  };

  const handleRefreshData = async () => {
    dispatch(loadingAction.showLoading());
    try {
      // console.log(date)
      let res = await post(REFRESH_RP_SHIFT_DATA, { SHIFT_DATE: date });
      if (res.resultCode == 200) {
        fetchData();
        dispatch(messageAction.showMessage("Refresh Success."));
      } else {
        dispatch(messageAction.showMessage(res.resultDescription));
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    // dispatch(loadingAction.hideLoading());
  }


  const handlerSaveShiftReport = async () => {
    // setModelDevice({ ...modelDevice, LIST_12HOUR: list12Hour, LIST_24HOUR: list24Hour });
    let dataShift = list12Hour.concat(list24Hour).map(obj => ({ ...obj, SCADA_DATA: parseFloat(obj.SCADA_DATA) }));
    // console.log(dataShift);
    if (validateForm()) {
      dispatch(loadingAction.showLoading());
      try {
        // let res = await post(SAVE_RP_SHIFT, modelDevice);
        let [dataHeader, dataSCADA] =
          await Promise.all([
            post(SAVE_RP_SHIFT, modelDevice),
            post(SAVE_LIST_RP_SHIFT_DATA_REPORT, dataShift),
          ]);
        if (dataHeader.resultCode != 200) {
          dispatch(messageAction.showMessage(dataHeader.resultDescription));
        } else if (dataSCADA.resultCode != 200) {
          dispatch(messageAction.showMessage(dataSCADA.resultDescription));
        } else {
          dispatch(messageAction.showMessage("Save success."));
        }
      } catch (error) {
        dispatch(messageAction.showMessage(error.message));
      }
      dispatch(loadingAction.hideLoading());
    } else {
      dispatch(messageAction.showMessage("Please complete the sender information."));
    }
  };

  useEffect(function () {
    let SHIFT_APPROVE = dropDownUser != null ? dropDownUser.value : null;
    let SHIFT_LEVEL = dropDownUser != null ? dropDownUser.shift : "";
    setModelDevice(preVent => ({
      ...preVent, SHIFT_APPROVE: SHIFT_APPROVE, SHIFT_LEVEL: SHIFT_LEVEL,
    }));
  }, [dropDownUser]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between pb-0">
                    <h1 className="mb-sm-0 font-size-20">
                      Shift ( Detail )
                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link to="/shift-report" style={{ color: "#556ee6" }}>
                            Shift
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Shift ( Detail )
                        </li>
                      </ol>
                    </div>
                  </div>

                  <hr />

                  <Row>
                    {/* <Col
                      sm="6"
                      className="d-flex align-items-center justify-content-start"
                    >
                      <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Gas Day : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{modelDevice.SHIFT_DAILY == undefined ? "" : moment(modelDevice.SHIFT_DAILY).locale('en')
                        .format(
                          "DD/MM/YYYY"
                        )}</span>
                    </Col> */}
                    <Col
                      sm="6"
                      className="d-flex align-items-center justify-content-start"
                    >
                      <button
                        type="button"
                        className="btn btn-info"
                        // onClick={handleRefreshData}
                        onClick={() => {
                          dispatch(
                            confirmAction.showConfirm(
                              "ต้องการ Refresh หรือไม่ ? หากต้องการ Refresh ระบบจะทำการล้างค่าปัจจุบัน",
                              () => {
                                handleRefreshData();
                              }
                            )
                          );
                        }}
                      >
                        <i className="mdi mdi-cloud-refresh fa-lg"></i>&nbsp;
                        Refresh Manual
                      </button>
                    </Col>

                    <Col
                      sm="6"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => gotoMainMenu()}
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>

                  <Row className="mt-2">
                    <Col sm="4" className="d-flex align-items-center justify-content-start">
                      <span style={{ fontSize: "1.8vh", color: "#FFFFFF" }}>เรียน : ผจ.บค </span>
                    </Col>
                    <Col sm="5" className="d-flex align-items-center justify-content-center">
                      <span style={{ fontSize: "1.8vh", color: "#FFFFFF" }}>รายงานการรับ-จ่ายก๊าซประจำวัน ส่วนบริหารและควบคุมระบบก๊าซ </span>
                    </Col>
                    <Col sm="3" className="d-flex align-items-center justify-content-center">
                      <span style={{ fontSize: "1.8vh", color: "#FFFFFF" }}>{modelDevice.SHIFT_DAILY == undefined ? "" : moment(modelDevice.SHIFT_DAILY).locale('th').format(
                        "dddd"
                      )} &nbsp;&nbsp;
                        วันที่ : &nbsp;&nbsp;
                        <span style={{ fontSize: "1.8vh", color: "#556ee6" }}>{modelDevice.SHIFT_DAILY == undefined ? "" : moment(modelDevice.SHIFT_DAILY).locale('th').add(543, 'year')
                          .format(
                            "LL"
                          )}</span>

                      </span>
                    </Col>
                  </Row>


                  <Row className="mt-2">
                    <Col sm="12">
                      <div style={{ width: "100%" }}>
                        {/* className="table-responsive" */}
                        {/* hover-table-highlight */}
                        <Table className="table table-bordered mb-0">
                          <thead style={{ fontSize: "1.3vh" }}>
                            <tr>
                              <th rowSpan={3} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>Time</th>
                              <th colSpan={5} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>42&quot; PIPELINE</th>
                              <th colSpan={2} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>Onshore#3</th>
                              <th colSpan={3} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>34&quot; PIPELINE</th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>

                              {/* <th colSpan={7} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>ONSHORE#1 PIPELINE</th>
                              <th colSpan={4} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>36&quot; PIPELINE</th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th> */}

                            </tr>
                            <tr>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.Arthit</th>
                              <th colSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.PRP</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TEMP 42&quot;</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.RY 42&quot;</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.OCS3</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>PI702BCS</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.B/K</th>
                              <th colSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.ERP</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.KN</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.ECPDISC.</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.PLT</th>

                              {/* <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TEMP PV-10</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.RY 34&quot;</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.OCS1</th>
                              <th colSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.BV# 6</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.SBK</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.ERPDISC.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.BJM.</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TEMP PV-141</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.RY 36&quot;</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>POCS2</th> */}

                            </tr>
                            <tr>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>INLET</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TO 42&quot;</th>

                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>INLET</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TO KN</th>

                              {/* <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>IN</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>OUT</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>BV#25</th>

                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>S.PAILIN</th> */}
                            </tr>
                          </thead>
                          <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.3vh" }}>
                            <tr>
                              <td>12:00</td>
                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.Arthit')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.Arthit'
                                    type="number"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.Arthit') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }
                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.Arthit')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'INLET')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='INLET'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'INLET') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }
                                    value={list12Hour.find(item => item.COLUMN_NAME == 'INLET')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'TO 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='TO 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TO 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'TO 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'TEMP 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='TEMP 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'TEMP 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.RY 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.RY 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.RY 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.OCS3')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.OCS3'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.OCS3') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.OCS3')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'PI702BCS')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='PI702BCS'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PI702BCS') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'PI702BCS')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.B/K')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.B/K'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.B/K') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.B/K')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'INET')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='INET'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'INET') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'INET')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'TO KN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='TO KN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TO KN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'TO KN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.KN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.KN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.KN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.KN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.ECP DISC.')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.ECP DISC.'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ECP DISC.') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.ECP DISC.')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.PLT')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.PLT'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.PLT') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.PLT')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='TEMP PV-10'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP PV-10') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='R.RY 34\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'R.RY 34\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P. OCS1'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P. OCS1') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'IN')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='IN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'IN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'IN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'OUT')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='OUT'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OUT') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'OUT')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.SBK'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.SBK') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='BV#25'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BV#25') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.ERP DISC'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ERP DISC') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='S.PAILIN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'S.PAILIN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'BJM')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='BJM'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BJM') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'BJM')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='PV-141'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PV-141') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.RY 36\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 36\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='OCS2'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OCS2') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td> */}
                            </tr>

                            <tr>
                              <td>24:00</td>
                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.Arthit')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.Arthit'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.Arthit') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.Arthit')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'INLET')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_INLET'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'INLET') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'INLET')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'TO 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_TO 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TO 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'TO 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'TEMP 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_TEMP 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'TEMP 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.RY 42\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.RY 42\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 42\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.RY 42\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.OCS3')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.OCS3'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.OCS3') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.OCS3')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'PI702BCS')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_PI702BCS'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PI702BCS') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'PI702BCS')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.B/K')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.B/K'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.B/K') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.B/K')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'INET')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_INET'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'INET') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'INET')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'TO KN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_TO KN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TO KN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'TO KN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.KN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.KN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.KN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.KN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.ECP DISC.')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.ECP DISC.'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ECP DISC.') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.ECP DISC.')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.PLT')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.PLT'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.PLT') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.PLT')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_TEMP PV-10'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP PV-10') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_R.RY 34\"'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'R.RY 34\"') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P. OCS1'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P. OCS1') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'IN')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_IN'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'IN') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'IN')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'OUT')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_OUT'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OUT') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'OUT')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.SBK'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.SBK') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_BV#25'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BV#25') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.ERP DISC'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ERP DISC') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_S.PAILIN'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'S.PAILIN') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'BJM')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_BJM'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BJM') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'BJM')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_PV-141'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PV-141') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.RY 36\"'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 36\"') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SHOW_DATA_SCADA}</td> */}
                              {/* <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_OCS2'
                                    type="text"
                                    errorMessage="Enter Value"
                                    className="form-control basicborder"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OCS2') {
                                            return { ...item, SHOW_DATA_SCADA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SHOW_DATA_SCADA}
                                  />
                                </AvForm>
                              </td> */}

                            </tr>

                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>





                  <Row className="mt-2">
                    <Col sm="12">
                      <div style={{ width: "100%" }}>
                        {/* className="table-responsive" */}
                        {/* hover-table-highlight */}
                        <Table className="table table-bordered mb-0">
                          <thead style={{ fontSize: "1.3vh" }}>
                            <tr>
                              <th rowSpan={3} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>Time</th>
                              <th colSpan={7} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>ONSHORE#1 PIPELINE</th>
                              <th colSpan={4} style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>36&quot; PIPELINE</th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>
                              <th style={{ backgroundColor: "#6c81e2bd", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}></th>
                            </tr>
                            <tr>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TEMP PV-10</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.RY 34&quot;</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.OCS1</th>
                              <th colSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.BV# 6</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.SBK</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.ERPDISC.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.BJM.</th>
                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>TEMP PV-141</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>P.RY 36&quot;</th>

                              <th rowSpan={2} style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>POCS2</th>
                            </tr>
                            <tr>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>IN</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>OUT</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>BV#25</th>

                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.2vw" }}>S.PAILIN</th>
                            </tr>
                          </thead>
                          <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.3vh" }}>
                            <tr>
                              <td>12:00</td>
                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='TEMP PV-10'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP PV-10') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='R.RY 34\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'R.RY 34\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P. OCS1'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P. OCS1') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'IN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='IN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'IN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'IN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'OUT')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='OUT'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OUT') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'OUT')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.SBK'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.SBK') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='BV#25'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BV#25') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.ERP DISC'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ERP DISC') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='S.PAILIN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'S.PAILIN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'BJM')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='BJM'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BJM') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'BJM')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='PV-141'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PV-141') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='P.RY 36\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 36\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list12Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='OCS2'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList12Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OCS2') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list12Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>
                            </tr>
                            <tr>
                              <td>24:00</td>
                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_TEMP PV-10'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'TEMP PV-10') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'TEMP PV-10')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_R.RY 34\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'R.RY 34\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'R.RY 34\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P. OCS1'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P. OCS1') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P. OCS1')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'IN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_IN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'IN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'IN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'OUT')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_OUT'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OUT') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'OUT')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.SBK'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.SBK') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.SBK')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_BV#25'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BV#25') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'BV#25')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.ERP DISC'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.ERP DISC') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.ERP DISC')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_S.PAILIN'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'S.PAILIN') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'S.PAILIN')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'BJM')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_BJM'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'BJM') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'BJM')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_PV-141'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'PV-141') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'PV-141')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_P.RY 36\"'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'P.RY 36\"') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'P.RY 36\"')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                              {/* <td>{list24Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SHOW_DATA_SCADA}</td> */}
                              <td style={{ width: "3vw" }}>
                                <AvForm className="needs-validation">
                                  <AvField
                                    // disabled={readonly == true || userActionType == "(Edit)"}
                                    name='24_OCS2'
                                    type="number"
                                    errorMessage="Enter Value"
                                    className="form-control"
                                    style={{ padding: "3px", color: "#FFFFFF", fontSize: "1.3vh", textAlign: "center" }}
                                    validate={{ required: { value: true } }}
                                    onChange={e =>
                                      setList24Hour(prevData => {
                                        return prevData.map(item => {
                                          if (item.COLUMN_NAME == 'OCS2') {
                                            return { ...item, SCADA_DATA: e.target.value };
                                          }
                                          return { ...item };
                                        })
                                      })
                                    }

                                    value={list24Hour.find(item => item.COLUMN_NAME == 'OCS2')?.SCADA_DATA}
                                  />
                                </AvForm>
                              </td>

                            </tr>

                          </tbody>
                        </Table>
                      </div>
                    </Col>
                  </Row>






























                  <Row className="mt-5">

                    <Col sm="7">
                      <div style={{ width: "100%" }}>
                        {/* className="table-responsive" */}
                        {/* hover-table-highlight */}
                        <Table className="table table-bordered mb-0">
                          <thead style={{ fontSize: "1.3vh" }}>
                            <tr>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>COMP.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>ERP</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>ECP</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>PRP</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>OCS1</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>OCS2</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>OCS3</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>OCS4</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>KCS</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>WCS</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>SCS</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>RCS</th>
                            </tr>
                          </thead>
                          <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.3vh" }}>
                            <tr>
                              <td>FUEL GAS</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'ERP')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'ECP')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'PRP')?.FLOWVOLUME}</td>
                              <td></td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'OCS2')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'OCS3')?.FLOWVOLUME}</td>
                              <td></td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'KCS')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'WCS')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'SCS')?.FLOWVOLUME}</td>
                              <td>{listDataFlow.find(item => item.METER_NAME == 'RCS')?.FLOWVOLUME}</td>
                              {/* <td>{listDataFlow != null ? numberFormat(listDataFlow[7].FLOWVOLUME, 2) : ""}</td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[2].FLOWVOLUME, 2) : ""}</td>
                              <td></td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[4].FLOWVOLUME, 2) : ""}</td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[5].FLOWVOLUME, 2) : ""}</td>
                              <td></td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[8].FLOWVOLUME, 2) : ""}</td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[6].FLOWVOLUME, 2) : ""}</td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[0].FLOWVOLUME, 2) : ""}</td>
                              <td>{listDataFlow != null ? numberFormat(listDataFlow[1].FLOWVOLUME, 2) : ""}</td> */}
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Col>
                    <Col sm="1">

                    </Col>
                    <Col sm="4">
                      <div style={{ width: "100%" }}>
                        {/* className="table-responsive" */}
                        {/* hover-table-highlight */}
                        <Table className="table table-bordered mb-0">
                          <thead style={{ fontSize: "1.3vh" }}>
                            <tr>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>Flow</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>Press.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>Temp.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>HV</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>Liq.</th>
                              <th style={{ backgroundColor: "#6C81E2", color: "#FFFFFF", textAlign: "center", width: "0.5vw" }}>FUEL Elec.</th>
                            </tr>
                          </thead>
                          <tbody style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.4vh" }}>
                            <tr>
                              <td>MMscfd</td>
                              <td>Psig</td>
                              <td>℉</td>
                              {/* &#8457;
                                &#x2109; */}
                              <td>BTU/SCF</td>
                              <td>BBLS</td>
                              <td>MWh</td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </Col>

                  </Row>






                  <Row>
                    <Col sm="8" className="mt-4">
                      <span style={{ color: "#FFFFFF", fontSize: "1.6vh" }}>
                        F-บค.บคต.-003 ประกาศใช้ครั้งที่ 5
                      </span>
                    </Col>
                    <Col sm="4" className="mt-4">
                      <FormGroup className="row">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                          ลงชื่อ
                        </Label>
                        <Col sm={8}>
                          <Select
                            id="SHIFT_APPROVE"
                            placeholder=""
                            isClearable={true}
                            value={dropDownUser}
                            onChange={handleSelectDropDownUser}
                            options={listUser}
                            classNamePrefix="form-require select2-selection"
                            styles={SelectStyle}
                            isDisabled={permission.eSTR != true}
                          />
                        </Col>
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Col sm="9"></Col>
                    <Col sm="3" className="mt-1">
                      <Label className="col-form-label d-flex align-items-center justify-content-center ms-5" style={{ fontSize: "16px", color: "#FFFFFF" }}>
                        พนักงานปฏิบัติการส่งก๊าซ
                      </Label>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <div className="d-flex align-items-center justify-content-end">
                      {permission.eSTR && (
                        <>
                          <Button
                            onClick={() => handlerSaveShiftReport()}
                            color="success"
                            className="btn w-md ms-2"
                          >
                            <i className="bx bx-save"> </i> &nbsp; Save
                          </Button>
                        </>
                      )}
                    </div>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  );
}

DetailShiftReport.propTypes = {
  t: PropTypes.any,
};


export default DetailShiftReport;
